var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthiconsExercise1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.326 74.3365L161.586 69.9797L183.37 151.278L167.11 155.635L157.307 119.051L92.2682 136.478L102.071 173.062L85.8112 177.419L64.0273 96.1204L80.2871 91.7636L90.0898 128.348L155.129 110.921L145.326 74.3365ZM49.4405 139.24L42.9053 114.85L59.165 110.494L74.4138 167.403L58.154 171.76L51.6189 147.37L43.489 149.548L41.3106 141.418L49.4405 139.24ZM206.086 105.98L197.957 108.159L204.492 132.548L188.232 136.905L172.983 79.9961L189.243 75.6393L195.778 100.029L203.908 97.8506L206.086 105.98Z",
    fill: "#7A51AE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthiconsExercise1);
export default __webpack_public_path__ + "static/media/healthicons_exercise (1).b46b298eb12e6b80ab9e0f08616aa0e8.svg";
export { ForwardRef as ReactComponent };